import { render, staticRenderFns } from "./modalRegistrarse.vue?vue&type=template&id=fabbb434&scoped=true&"
import script from "./modalRegistrarse.vue?vue&type=script&lang=js&"
export * from "./modalRegistrarse.vue?vue&type=script&lang=js&"
import style0 from "./modalRegistrarse.vue?vue&type=style&index=0&id=fabbb434&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabbb434",
  null
  
)

export default component.exports